export const RedemptionOrderPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'sales.redemptionOrder.list-view',
    UPDATE: 'sales.redemptionOrder.list-update',
    DELETE: 'sales.redemptionOrder.list-delete',
  },
});
